export default {
  path: '/subscription-statistics',
  auth: true,
  preload: false,
  key: 'subscription-statistics',
  layout: 'inner', // outer 一级菜单 inner 二级菜单
  component: () => import('./index')
};
